import { createSelector } from "reselect";
import { DateHelper } from "shared/helpers/DateHelper";

const getPlanItems = (state) => state.items;
const getToday = (state) => state.today;
const getDueItems = (state) => state.dueItems;

export const getCombinedItems = createSelector(
  [getPlanItems, getToday, getDueItems],
  (planItems, today, dueItems) => {
    return dueItems.concat(todayProps(today)).concat(planItems);
  }
);

export function todayProps(today) {
  return {
    day_name: "Today",
    day: DateHelper.dateString(today),
    type: "day_name",
  };
}
